<div class="edit-container" *ngIf="isAdmin() || showEdit()">
  <div class="sidebar left edit_block_wrapper" *ngIf="isAdmin()">
    <div class="edit_block not_mobile_only">
      <button type="button" class="btn btn--submit float-end" [disabled]="!updateItem" (click)="hidesLiterals = !hidesLiterals" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')">{{ 'COMMON.EDIT_LITERALS' | translate }}</button>
    </div>
    <div [hidden]="hidesLiterals" class="literals-container">
      <div class="literals">
        <div class="literal" *ngFor="let literal of editableLiterals">
          <div><strong>{{ 'EDITION_PANEL.' + literal.property.toUpperCase() | translate }}</strong></div>
          <div class="literal-translations" *ngFor="let translation of literal.translationsMap; let i = index;">
            <span>{{ 'COMMON.LANGS_LONG_' + translation.language.toUpperCase() | translate }}:</span>
            <input type="text" class="form-control" [(ngModel)]="translation['name']" name="name{{i}}" #name="ngModel">
          </div>
        </div>
      </div>
      <div class="save-button">
        <button type="button" class="btn btn--submit float-end" (click)="saveLiteralsBtn()" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')">{{ 'COMMON.SAVE' | translate }}</button>
      </div>
    </div>
  </div>
  <div class="edit_block_wrapper pointer" *ngIf="showEdit() && !hidesEditItem">
    <div class="edit_block not_mobile_only">
      <button type="button" class="btn btn--submit float-end" (click)="goToEdit()" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')">{{ 'COMMON.EDIT' | translate }}</button>
    </div>
  </div>
  <div class="sidebar right edit_block_wrapper" *ngIf="isAdmin()">
    <div class="edit_block not_mobile_only">
      <button type="button" class="btn btn--submit float-end" [disabled]="!updateItem" (click)="hidesDetails = !hidesDetails" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')">{{ 'COMMON.EDIT_DETAILS' | translate }}</button>
    </div>
    <div [hidden]="hidesDetails" class="details-container">
      <div class="details">
        <div class="detail" *ngFor="let editableDetailsPrepared of editableDetailsPrepared">
          <span>{{ 'EDITION_PANEL.' + editableDetailsPrepared['detailKey'].toUpperCase() | translate }}</span>
          <div class="edit_right" *ngIf="editableDetailsPrepared['detailType'] === 'BOOLEAN'">
            <input type="checkbox" class="custom-control-input" id="customCheck1" [(ngModel)]="editableDetailsPrepared['detailValue']">
          </div>
          <div class="edit_right" *ngIf="editableDetailsPrepared['detailType'] === 'INT'">
            <input type="number" class="form-control form-control-color" id="exampleColorInput" [(ngModel)]="editableDetailsPrepared['detailValue']" title="Choose your number">
          </div>
          <div class="edit_right" *ngIf="editableDetailsPrepared['detailType'] === 'STRING' && editableDetailsPrepared['detailProperty'] === 'EMPTY'">
            <input type="checkbox" class="custom-control-input" id="customCheck1" [(ngModel)]="editableDetailsPrepared['detailValue']">
          </div>
          <div class="edit_right" *ngIf="editableDetailsPrepared['detailProperty'] === 'COLOR'">
            <input type="color" class="form-control form-control-color" id="exampleColorInput" [(ngModel)]="editableDetailsPrepared['detailValue']" title="Choose your color">
          </div>
        </div>
      </div>
      <div class="save-button">
        <div class="mb-2">{{ 'EDITION_PANEL.DETAILS.MESSAGE' | translate }}</div>
        <button type="button" class="btn btn--submit float-end" (click)="saveDetails(editableDetailsPrepared)" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')">{{ 'COMMON.SAVE' | translate }}</button>
      </div>
    </div>
  </div>
</div>